import { createFeatureSelector, createSelector } from "@ngrx/store";
import { featureName } from "./nav.reducer";
import { INav } from "../../types/nav";
export const selectNavState = createFeatureSelector<INav>(featureName);
export const selectNavSnav = createSelector(selectNavState, (state) => state.snav);
export const selectNavLinks = createSelector(selectNavState, (state) => state.links);
